import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { useLocation } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { withIntl, TranslatorContext, IntlContext } from '@jutro/locale';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { Icon } from '@jutro/components';
import { PolicyService } from 'gw-capability-policy';
import { generateURL } from 'gw-portals-url-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { GatewayClaimService } from 'gw-capability-ri-claim';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './ClaimsFrame.metadata.json5';
import styles from './ClaimsFrame.module.scss';

function ClaimsFrame(props) {
    const translator = useContext(TranslatorContext);

    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const location = useLocation();
    const intl = useContext(IntlContext);
    const auth = useAuthentication();

//    const { claimNumber, policyNumber} = location.state;
    const [isPreview, setIsPreview] = useState(false);
    const [file, setFile] = useState({});
    const [fileUploadString, setFileUploadString] = useState('');
    const [isAlert, setIsAlert] = useState(false);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const [policyNumber, setPolicyNumber] = useState('');

    useEffect(() => {
        // loadClaimData();
        // This method has to be executed only once when landing on claim list page
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setLoadingState(true);
        Promise.all(
            [
                PolicyService.getAccountPolicySummaries(authHeader).then(setAccountPolicyData),
            ]
        ).finally(() => {
            setLoadingState(false);
        });
    }, []);

    useEffect(() => {
        setPolicyDataConst(accountPolicyData);
    }, [accountPolicyData]);


    const setPolicyDataConst = (accountPolicyData) => {
        if (accountPolicyData != null) {
            accountPolicyData.find((policyData) => {
                policyData.periods.find((period) => {
                    if (period.policyId) {
                        setPolicyNumber(period.policyId);
                    }
                });
            });    
        }      
    };

    const generateEClaimsURL = () => {
        try {
            const getUrl = window.location;
            let baseUrl = `${getUrl.origin}/claims/eclaim/#/eclaim`;
            
            if (location.state?.fnolid) {
                baseUrl = `${getUrl.origin}/claims/eclaim/#/eclaim/${location.state.fnolid}`;
            }
            
            // Use optional chaining to safely access appConfig and auth properties
            const redirectRoute = appConfig?.documentNotFoundRedirectUrl || '';
            const userId = auth?.user_name 
                ? auth.user_name.replace('policyholder_portal_', '') 
                : '';
            
            const params = {};
            // If these variables are meant to be used, add them to params
            // params.redirect = redirectRoute;
            // params.userId = userId;
            
            return generateURL(baseUrl, params);
        } catch (error) {
            console.error('Error generating eClaims URL:', error);
            // Return a safe fallback URL
            return `${window.location.origin}/claims/eclaim/#/eclaim`;
        }
    };

    const getFileAClaimHeader = () => {
        return (
            <>
                <div className={styles.gwTypeWithLOB}>

                    <Icon icon="mi-file-medical" className={styles.syncIcon} />
                    <h1 className={styles.gwPageTitle}>File a Claim</h1>
                </div>
            </>
        );
    };

    const getBlankDivider = () => {
        return (
            <div className={styles.isdividerhorizontal}>OR</div>
        );
    };

    const uploadFile = async() => {
        setLoadingState(true);
        const formData = new FormData();
        formData.append('description', '5020 (Employer 1st Report)');
        formData.append('policy', policyNumber);
        formData.append('claim', '');
        formData.append('doctype', 'RPT_ER1ST');
        formData.append('file', file);

        setLoadingState(false);

        await GatewayClaimService.uploadFile(formData, authHeader)
          .then((response) => {     
            setIsPreview(false);
            setIsAlert(true);
          })
          .catch(({ error = {} }) => {
            alert(`error upload file: ${error}`);
          })
          .finally(() => {
              setLoadingState(false);
          });
  
    };    

    const doUpload = useCallback(() => {
        uploadFile();
        setFile({});
        setFileUploadString('');
    });

    const handleOnUpload = useCallback((file) => {
        setFileUploadString(`${file.name} ,Size: ${file.size} Bytes`);
        setFile(file);
    });

    const handleOnCancel = () => {
        setFileUploadString('');
        setFile({});
        setIsPreview(false);
    };

    const alertCloseFn = useCallback(() => {
        setIsAlert(false);
    });

    const previewUpload = useCallback((file ) => {
        setFile(file);
        setFileUploadString(`${file.name} ,Size: ${file.size} Bytes`);
        setIsPreview(true);
    });
 
    const overrides = {
        iframeClaims: {
            src: generateEClaimsURL()
        },
        tabClaimsTitle: {
            content: getFileAClaimHeader()
        },
        tabBlank: {
            content: getBlankDivider()
        },
        documentsTableContainer: {
            visible: false
        },
        fileUploadButtonId:{
            visible: isPreview && !isAlert
        },
        cancelButtonId:{
            visible: isPreview && !isAlert
        },
        inlineNnotification:{
            visible: isAlert
        },
        uploadDocument: {
            value: fileUploadString
          }        
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            doUpload,
            uploadFile,
            previewUpload,
            handleOnCancel,
            handleOnUpload,
            alertCloseFn
        },
        resolveComponentMap: {
        }
    };


    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default withIntl(withAuthenticationContext(ClaimsFrame));
